<template>
  <div id="app">
    <DrawerHandles @open="open" />
    <drawer ref="menu" :openDrawer="openDrawer" @close="openDrawer = null" />
    <Notepad ref="notepad" :openDrawer="openDrawer" @close="openDrawer = null" />
    <Chat ref="chat" :openDrawer="openDrawer" @close="openDrawer = null" />
    <NotificationContainer/>
    <transition name="fade">
      <AppHeader />
    </transition>

    <transition :name="transitionName" mode="out-in">
      <router-view :key="$route.fullPath"/>
    </transition>
    <transition name="fade">
      <modal />
    </transition>
  </div>
</template>

<script>
import DrawerHandles from '@/components/DrawerHandles.vue'
import Drawer from '@/components/Drawer.vue'
import Chat from '@/components/Chat.vue'
import Notepad from '@/components/Notepad.vue'
import AppHeader from '@/components/AppHeader.vue'
import Modal from '@/components/Modal.vue'
import NotificationContainer from '@/components/NotificationContainer.vue'
// import TimelineContainer from '@/components/TimelineContainer.vue';

export default {
  name: "app",
  components: {
    DrawerHandles,
    'drawer': Drawer,
    'modal': Modal,
    // 'timeline-container': TimelineContainer,
    AppHeader,
    NotificationContainer,
    Notepad,
    Chat
  },
  data () {
    return {
      openDrawer: null,
      transitionName: 'fade',
      // headerComponent: ScenarioHeader
    }
  },
  methods: {
    open (type) {
      this.openDrawer = type
    }
  },
  watch: {
    '$route' (to, from) {
      const toS = to.params.scenarioId
      const fromS = from.params.scenarioId
      if ( toS && toS === fromS ) {
        const toP = to.params.playlistId
        const fromP = from.params.playlistId
        this.transitionName = toP < fromP ? 'slide-to-right' : 'slide-to-left'
      } else {
        this.transitionName = 'fade'
      }
    }
  }
}
</script>

<style lang="scss">
:root {
  --primary: #0728D1;
  --orange: #DEAC3D;
  --container-width: 900px;
  --border-radius: 5px;
}
* {
  box-sizing: border-box;
}
body {
  margin: 0;
}
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #000;
  

  max-width: 100vw;
  // overflow: hidden;
  min-height: 100vh;
  padding-bottom: 50px;

  @media all and (min-width: 768px) {
    // padding-left: 40px;
    // padding-right: 40px;
    padding-bottom: 100px;
  }
}

button {
  cursor: pointer;
  border: none;
  background: none;

  &:focus {
    outline: none;
  }

  &.text {
    font-size: 15px;
    color: var(--primary)
  }
}
h1, h2, h3, h4 {
  margin: 0;
  line-height: 1.2em;
}

textarea {
  width: 100%;
}

.shadowed {
  // box-shadow: -2px 2px 30px 6px #00000029;
  box-shadow: 0px 0px 99px rgba(0, 0, 0, 0.16);

  &.white {
    background-color: #fff;
  }
}

.rounded {
  border-radius: var(--border-radius);
  overflow: hidden;
}

.bordered {
  border: 2px solid var(--primary);
}

.btn {
  @extend .rounded;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  // box-shadow: -2px 2px 20px 6px #00000029;
  // border: 1px solid #000;
  transition: all .25s cubic-bezier(0.22, 0.61, 0.36, 1) 0s;
  text-decoration: none;
  color: #fff;
  font-size: 16px;
  background-color: var(--primary);
  height: 40px;
  border: 2px solid var(--primary);

  i {
    margin: 0 10px 0 -10px;
  }
  span + i {
    margin: 0 -10px 0 10px;
  }

  &.light {
    background-color: #fff;
    color: var(--primary);
  }

  &.large {
    font-size: 20px;
    font-weight: bold;
    height: 70px;
    width: 100%;
    text-align: center;
    border-radius: 0;

    span,
    i {
      margin-left: auto;
    }
    i {
      font-size: 30px;
    }

    &:hover {
      transform: scale(1);
      background-color: lighten(#0728D1, 10%);
    }
  }

  &:hover {
    transform: scale(1.1);
  }

  &.inverted {
    border-color: #fff;
    color: #fff;
    background-color: transparent;
  }
  &:disabled {
    background-color: #cecece;
    color: #666;
  }
  &.inline {
    display: inline-flex;
  }
}

.-large-title {
  font-size: 52px;
  font-weight: 900;
  color: var(--primary);
}
.-text-error {
  background-color: rgb(233, 177, 177) !important;
}
.-text-success {
  background-color: #b6f3d7 !important;
}

.mobileSelect .content .btnBar .ensure,
.mobileSelect .content .btnBar .cancel {
  @extend .btn
}

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: #1a1a9b;
    color: white;
    border-radius: 5px;
    padding: 5px 10px 4px;
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 15px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #1a1a9b;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.slide-to-left-enter-active, .slide-to-left-leave-active {
  transition: transform .4s;
}
.slide-to-left-enter  /* .slide-to-left-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
}
.slide-to-left-leave-to {
  transform: translateX(-100%);
}

.slide-to-right-enter-active, .slide-to-right-leave-active {
  transition: transform .4s;
}
.slide-to-right-enter  /* .slide-to-right-leave-active below version 2.1.8 */ {
  transform: translateX(-100%);
}
.slide-to-right-leave-to {
  transform: translateX(100%);
}

.slide-to-top-enter-active, .slide-to-top-leave-active {
  transition: transform .4s;
}
.slide-to-top-enter  /* .slide-to-top-leave-active below version 2.1.8 */ {
  transform: translateY(100%);
}
.slide-to-top-leave-to {
  transform: translateY(-100%);
}

.slide-to-bottom-enter-active, .slide-to-bottom-leave-active {
  transition: transform .4s;
}
.slide-to-bottom-enter  /* .slide-to-bottom-leave-active below version 2.1.8 */ {
  transform: translateY(-100%);
}
.slide-to-bottom-leave-to {
  transform: translateY(100%);
}

.note-enter-active {
  transition: opacity .4s;
}
.note-enter {
  opacity: 0;
}
.note-leave-active {
  transition: transform .25s;
}
.note-leave-to {
  transform: translateX(-100%);
}

.accordeon-toggle-enter-active, .accordeon-toggle-leave-active {
  transition: transform .4s;
}
.accordeon-toggle-leave-to,
.accordeon-toggle-enter  /* .accordeon-toggle-leave-active below version 2.1.8 */ {
  transform: translateX(-100%);
}

.side-toggle-enter-active, .side-toggle-leave-active {
  transition: transform .4s;
}
.side-toggle-leave-to,
.side-toggle-enter  /* .side-toggle-leave-active below version 2.1.8 */ {
  transform: translateX(-100%);
}


.slide-in {
  
  &-move {
    transition: opacity .5s linear, transform .5s ease-in-out;
  }
  
  &-leave-active {
    transition: opacity .4s linear, transform .4s cubic-bezier(.5,0,.7,.4); //cubic-bezier(.7,0,.7,1); 
    transition-delay: calc( 0.1s * (var(--total) - var(--i)) );
  }
  
  &-enter-active { 
    transition: opacity .5s linear, transform .5s cubic-bezier(.2,.5,.1,1);
    transition-delay: calc( 0.1s * var(--i) );
  }

  &-enter, 
  &-leave-to {
    opacity: 0;
  }
  
  &-enter { transform: translateX(-1em); }
  &-leave-to { transform: translateX(1em); }

}



</style>
